<template>
  <q-form ref="editForm">
    <c-card title="기본정보" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <!-- <c-btn 
            v-show="safHeaAuthDeleteEditable" 
            :url="deleteAuthUrl"
            :isSubmit="isDeleteAuth"
            :param="tabParam"
            mappingType="PUT"
            label="삭제" 
            icon="remove"
            auth="SAFHEA"
            @beforeAction="deleteAuth"
            @btnCallback="deleteAuthCallback" />
          <c-btn 
            v-show="editable && !disabled && tabParam.sopCtoId" 
            label="삭제" 
            icon="delete_forever" 
            @btnClicked="remove" />
          <c-btn
            v-if="!disabled && editable"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="tabParam"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveCto"
            @btnCallback="saveCallback" 
          />
          <c-btn 
            v-show="!disabled && tabParam.sopCtoId && editable"
            :isSubmit="isComplete"
            :url="completeUrl"
            :param="tabParam"
            mappingType="PUT"
            label="완료" 
            icon="check"
            @beforeAction="completeCto"
            @btnCallback="completeCallback" /> -->
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-text
            required
            :editable="editable"
            :disabled="disabled"
            label="패트롤명"
            name="mdmSopId"
            v-model="tabParam.mdmSopId">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            required
            :editable="editable"
            type="date"
            :disabled="disabled"
            label="패트롤일"
            name="ctoDate"
            v-model="tabParam.ctoDate"
          />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :editable="editable"
            type="time"
            :disabled="disabled"
            :minuteStep="10"
            label="소요시간"
            name="ctoTime"
            v-model="tabParam.ctoTime"
          />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-text
            :editable="editable"
            :disabled="disabled"
            label="작업구역"
            name="workArea"
            v-model="tabParam.workArea">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-multi-field
            required
            :editable="editable"
            :disabled="disabled"
            :data="tabParam"
            label="패트롤자"
            name="observeUserId"
            v-model="tabParam.observeUserId">
          </c-multi-field>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-text
            suffix="명"
            type="number"
            :editable="editable"
            :disabled="disabled"
            label="관찰인원"
            name="observeCount"
            v-model="tabParam.observeCount">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-plant 
            required
            :disabled="disabled"
            :editable="editable" 
            type="edit" 
            name="plantCd" 
            v-model="tabParam.plantCd" />
        </div>
      </template>
    </c-card>
    <c-card title="총평" class="cardClassDetailForm" :collapsed="true" :basicExpand="false">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <c-multi-select
            codeGroupCd="CTO_WORK_CHARACTER_CD"
            :editable="editable"
            :disabled="disabled"
            itemText="codeName"
            itemValue="code"
            maxValues="3"
            name="workCharacteristics"
            label="작업특성"
            v-model="tabParam.workCharacteristics">
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <c-multi-select
            codeGroupCd="CTO_HUMAN_FACTOR_CD"
            :editable="editable"
            :disabled="disabled"
            itemText="codeName"
            itemValue="code"
            maxValues="3"
            name="humanFactors"
            label="인적요소"
            v-model="tabParam.humanFactors">
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <c-multi-select
            codeGroupCd="CTO_CORE_ACTION_ITEMS_CD"
            :editable="editable"
            :disabled="disabled"
            itemText="codeName"
            itemValue="code"
            maxValues="3"
            name="coreActionItems"
            label="핵심행동항목"
            v-model="tabParam.coreActionItems">
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <c-textarea
            :editable="editable"
            :disabled="disabled"
            label="우선사항"
            :rows="2"
            name="priorityContents"
            v-model="tabParam.priorityContents">
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <c-textarea
            :editable="editable"
            :disabled="disabled"
            label="개선사항"
            :rows="2"
            name="improveContents"
            v-model="tabParam.improveContents"
          />
        </div>
      </template>
    </c-card>
    <c-card title="핵심행동 목록" class="cardClassDetailForm" :collapsed="true" :basicExpand="false">
      <template slot="card-detail">
        <div class="col-12">
          <c-table
            ref="activityTable"
            title=""
            :columns="grid.columns"
            :gridHeight="grid.height"
            :data="tabParam.activityModels"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            noDataLabel="핵심행동을 추가하세요."
            :hideBottom="true"
            :editable="editable&&!disabled"
            rowKey="sopCtoActivityId"
            selection="multiple"
          >
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn v-if="editable && !disabled" :showLoading="false" label="추가" icon="add" @btnClicked="addActivity" />
                <c-btn v-if="editable && !disabled && tabParam.activityModels.length > 0" :showLoading="false"  label="제외" icon="remove" @btnClicked="removeActivity" />
              </q-btn-group>
            </template>
          </c-table>
        </div>
      </template>
    </c-card>
    <div class="popup-bottom-bar">
      <div class="popup-bottom-bar-btngroup">
        <q-btn-group outline >  
          <c-btn 
            :flat="true"
            v-show="safHeaAuthDeleteEditable" 
            :url="deleteAuthUrl"
            :isSubmit="isDeleteAuth"
            :param="tabParam"
            mappingType="PUT"
            label="삭제" 
            icon="remove"
            auth="SAFHEA"
            @beforeAction="deleteAuth"
            @btnCallback="deleteAuthCallback" />
          <c-btn 
            :flat="true"
            v-show="editable && !disabled && tabParam.sopCtoId" 
            label="삭제" 
            icon="delete_forever" 
            @btnClicked="remove" />
          <c-btn
            :flat="true"
            v-if="!disabled && editable"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="tabParam"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveCto"
            @btnCallback="saveCallback" 
          />
          <c-btn 
            :flat="true"
            v-show="!disabled && tabParam.sopCtoId && editable"
            :isSubmit="isComplete"
            :url="completeUrl"
            :param="tabParam"
            mappingType="PUT"
            label="완료" 
            icon="check"
            @beforeAction="completeCto"
            @btnCallback="completeCallback" />
        </q-btn-group>
      </div>
      <div class="popup-bottom-bar-close">
        <q-btn flat color="gray" icon="arrow_back" @click="closePopUps" />
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from 'quasar'
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'cto-info',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        sopCtoId: '',
        plantCd: '',
        ctoDate: '',
        ctoTime: '',
        observeUserId: '',
        observeCount: '',
        mdmSopId: '',
        workArea: '',
        ctoCompleteFlag: 'N',
        improveContents: '',
        priorityContents: '',
        managerUserId: '',
        sopName: '',
        regUserId: '',
        chgUserId: '',
        workCharacteristics: '',
        humanFactors: '',
        coreActionItems: '',
        activityModels: [],
        ctoChecklistModels: [],
        ctoImproveModels: [],
        deleteActivityModels: [],
      }),
    },
  },
  data() {
    return {
      editable: true,
      searchUrl: '',
      grid: {
        columns: [],
        height: '300px'
      },
      saveUrl: 'transactionConfig.sop.cto.basic.insert.url',
      completeUrl: 'transactionConfig.sop.cto.basic.insert.url',
      saveType: 'POST',
      isSave: false,
      isComplete: false,
      isDeleteAuth: false, // (권한)삭제 flag
      getUrl: '',
      insertUrl: '',
      deleteUrl: '',
      deleteAuthUrl: '',
      updateUrl: '',
      updateMode: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    disabled() {
      return this.editable && Boolean(this.tabParam.ctoCompleteFlag) && this.tabParam.ctoCompleteFlag === 'Y'
    },
    safHeaAuthDeleteEditable() {
      return this.editable // 쓰기권환
        && this.tabParam.ctoCompleteFlag === 'Y' // 완료된 경우
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.insertUrl = transactionConfig.sop.cto.basic.insert.url;
      this.updateUrl = transactionConfig.sop.cto.basic.update.url;
      this.deleteUrl = transactionConfig.sop.cto.basic.delete.url;
      this.deleteAuthUrl = transactionConfig.sop.cto.basic.delete.auth.url;
      this.completeUrl = transactionConfig.sop.cto.basic.complete.url;
      // list setting
      this.setHeader();
    },
    setHeader() {
      this.$comm.getComboItems('CTO_GOOD_BAD_CD').then(_item => {
        this.grid.columns = [
          {
            name: 'mainActivity',
            field: 'mainActivity',
            label: '핵심행동',
            align: 'left',
            style: 'width:50%',
            type: 'text',
            sortable: false,
          },
          {
            name: 'goodBadCd',
            field: 'goodBadCd',
            label: '양호/불량/해당없음',
            type: 'select',
            setHeader: true,
            style: 'width:20%',
            align: 'center',
            comboItems: _item,
            sortable: false,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            type: 'textarea',
            style: 'width:30%',
            align: 'center',
            sortable: false
          },
        ]
      });
    },
    saveCto() {
      if (this.tabParam.sopCtoId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.tabParam.regUserId = this.$store.getters.user.userId
              this.tabParam.chgUserId = this.$store.getters.user.userId
              
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('changeStatus', result.data)
    },
    addActivity() {
      this.tabParam.activityModels.splice(0, 0, {
        sopCtoId: this.tabParam.sopCtoId,
        sopCtoActivityId: uid(),
        goodBadCd: 'CGB0000003',
        mainActivity: '',
        remarks: '',
        regUserId: '',
        chgUserId: '',
        editFlag: 'C'
      })
    },
    removeActivity() {
      let selectData = this.$refs['activityTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.tabParam.deleteActivityModels) {
            this.tabParam.deleteActivityModels = []
          }
          if (this.$_.findIndex(this.tabParam.deleteActivityModels, { sopCtoActivityId: item.sopCtoActivityId }) === -1
            && item.editFlag !== 'C') {
              this.tabParam.deleteActivityModels.push(item)
          }
          this.tabParam.activityModels = this.$_.reject(this.tabParam.activityModels, item)
        })
      }
    },
    // openSop() {
    //   this.popupOptions.title = 'SOP 검색'; // SOP 검색
    //   this.popupOptions.param = {
    //     type: 'single',
    //     searchType: '1', //1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 4:작업단계별 유해위험요인별 원인/결과
    //   };
    //   this.popupOptions.target = () => import(`${'@/pages/common/process/sopPop.vue'}`);
    //   this.popupOptions.width = '70%';
    //   this.popupOptions.visible = true;
    //   this.popupOptions.closeCallback = this.closeSopPopup;
    // },
    // closeSopPopup(data) {
    //   this.popupOptions.target = null;
    //   this.popupOptions.visible = false;
    //   if (data && data.length > 0) {
    //     this.tabParam.mdmSopId = data[0].mdmSopId;
    //     this.tabParam.sopName = data[0].sopName;
    //     this.tabParam.processName = data[0].processName;
    //   }
    // },
    // removeSop() {
    //   this.tabParam.mdmSopId = '';
    //   this.tabParam.sopName = '';
    //   this.tabParam.processName = '';
    // },
    completeCto() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '안전보건팀 패트롤을 완료하시겠습니까?\n완료할 시 [안전보건팀 패트롤 정보, 방지 및 감소대책]을 수정 할 수 없습니다.',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.tabParam.regUserId = this.$store.getters.user.userId
              this.tabParam.chgUserId = this.$store.getters.user.userId
              
              this.tabParam.ctoCompleteFlag = 'Y'
              this.isComplete = !this.isComplete;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getDetail')
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '패트롤을 삭제하시겠습니까? 모든 정보가 삭제됩니다.',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.tabParam.sopCtoId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup', 'REMOVE');  
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    /**
     * (권한) 삭제
     */
    deleteAuth() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?\n(※ [시나리오, 개선, 위험등록부] 포함 모든 위험등록부 정보가 삭제됩니다.)',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.isDeleteAuth = !this.isDeleteAuth;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    deleteAuthCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('closePopup');  
    },
    closePopUps() {
      this.$emit('closePopup')
    },
  }
};
</script>
